export default __webpack_public_path__ + "static/media/lupa not found.8d3ab30f.svg";